/**
 * action types
 */
export const SET_INSTITUTIONS = 'SET_INSTITUTIONS';
export const INSTITUTION_FEATURED_FETCH_START =
  'INSTITUTION_FEATURED_FETCH_START';
export const INSTITUTION_FEATURED_FETCH_SUCCESS =
  'INSTITUTION_FEATURED_FETCH_SUCCESS';
export const INSTITUTION_FEATURED_FETCH_FAILURE =
  'INSTITUTION_FEATURED_FETCH_FAILURE';

export const FETCH_INSTITUTION_ROLES_START = 'FETCH_INSTITUTION_ROLES_START';
export const FETCH_INSTITUTION_ROLES_SUCCESS =
  'FETCH_INSTITUTION_ROLES_SUCCESS';
